<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>

    <v-alert
      v-if="infoMessages"
      :value="true"
      id="infoAlert"
      dismissible
      color="#2A3B4D"
      border="top"
      dark
    >
      <div v-for="(infoMessage, k) in infoMessages" v-bind:key="infoMessage.id">
        <div class="text-h6">
          {{ infoMessage.title }}
        </div>
        <div v-html="infoMessage.message"></div>
        <hr
          v-if="k < infoMessages.length - 1"
          style="margin: 10px 0px 10px 0px"
        />
      </div>
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
const default_layout = "no-sidebar";

export default {
  data: () => ({
    validForm: true,
  }),
  computed: {
    ...mapState("app", ["config"]),
    infoMessages() {
      if (this.config.maintenance) {
        let ret = this.config.maintenance.filter((el) => {
          return el.allowLogin;
        });

        if (
          this.config.maintenance.filter((el) => {
            return !el.allowLogin;
          }).length &&
          this.$route.name != "login"
        ) {
          this.logout();
        }

        return ret.length ? ret : false;
      }
      return false;
    },
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },
  created() {
    this.getConfig();

    setInterval(() => {
      this.getConfig();
    }, 1000 * 30);
  },
  updated() {},
  methods: {
    ...mapActions("app", ["getConfig"]),
    ...mapActions("user", ["logout"]),
  },
};
</script>


<style>
#infoAlert {
  text-align: left;
  position: fixed !important;
  min-width: 400px;
  max-width: 550px;
  text-align: left;
  bottom: 10px;
  right: 20px;
  width: 500px;
}

.v-date-picker-table .v-btn.v-btn--icon {
  width: 32px;
  height: 32px;
}
.v-date-picker-table .v-btn {
  padding: 0px;
}

.v-date-picker-table .v-btn.v-btn--icon {
  position: absolute;
  margin: -5px;
}
</style>
